import { Panel } from '../ui/Panel';
import { Toggle } from '../ui/Toggle';
import { useAdmin } from '../AdminContext';

/**
 * Per merk: mag er aan de kassa korting op (KASSA-ABONNEMENTEN §2)? Standaard uit, omdat merken vaak een
 * vaste verkoopprijs vragen. Gaat mee met de Opslaan-balk, zoals de rest van de catalogus.
 */
export function BrandDiscounts() {
  const {
    catalog,
    setCatalog
  } = useAdmin();
  if (catalog.brands.length === 0) return null;
  const set = (name: string, discountAllowed: boolean) => setCatalog(c => ({
    ...c,
    brands: c.brands.map(b => b.name === name ? {
      ...b,
      discountAllowed
    } : b)
  }));
  return <Panel title="Korting aan de kassa" description="Mag je een product van dit merk aan de kassa goedkoper verkopen? Uit: de prijs op de bon ligt vast. Behandelingen mogen altijd korting, met een reden." data-id="element-622" data-mp="2nw46c4jw8lwr">
      <div className="space-y-5" data-id="element-623" data-mp="1cjjt0q2vjau0">
        {catalog.brands.map(b => <Toggle key={b.name} checked={b.discountAllowed === true} onChange={on => set(b.name, on)} label={b.name} description={b.discountAllowed ? 'Korting mag, met een reden op de bon.' : 'Geen korting: vaste prijs.'} data-id="element-624" data-mp="18fc3iqoldquq" />)}
      </div>
    </Panel>;
}